import formatRangeFilterValue from '@/catalog/helpers/formatRangeFilterValue';
import { FilterValue } from '@/catalog/types/filterValue';
import { OPTICAL_METRIC_MARKS } from '@/metric/constants/marks';

export function formatGradeValue({ from, to }: FilterValue, marks: string[] = OPTICAL_METRIC_MARKS) {
  const marksLength = marks.length;

  let fromMark: Nullable<string> = null;
  let toMark: Nullable<string> = null;

  if (from) {
    const fromPosition = Math.ceil(from * marksLength) - 1;

    fromMark = marks[fromPosition];
  }

  if (to) {
    const toPosition = Math.ceil(to * marksLength) - 1;

    toMark = marks[toPosition];
  }

  return formatRangeFilterValue({
    from: fromMark,
    to: toMark,
  });
}
